// Tiny module-scope bridge between the copilot chat (mounted at the app root,
// above the router) and the campaign builder tree (mounted per route). The
// provider callbacks can't reach builder contexts through React context — the
// trees are siblings — so events cross via this emitter instead of a DOM
// CustomEvent (typed, no string-name coupling).
//
// Event shape (client-copilot-v2 refetch-sync contract):
//   { name: "campaign_updated",
//     payload: { campaignId?: string, kinds: string[] | "all" },
//     senderId: string | null }
// Interim transport (library 0.4.x): the chat can only observe THAT an agent
// message arrived (onIncomingMessage), so ClientChat emits kinds:"all" with no
// campaignId. Once @oppizi-ecosystem/copilot ships onAgentEvent (0.5.0), the
// hidden event message's parsed payload flows through unchanged.

const listeners = new Set();

export const emitAgentEvent = (event) => {
  for (const listener of [...listeners]) {
    try {
      listener(event);
    } catch (error) {
      console.error("copilot agent-event listener failed:", error);
    }
  }
};

export const subscribeAgentEvents = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Targeting lives in its own provider that mounts only while the Targeting
// step is open, and its saved-selection rehydrate is guarded by a one-shot
// flag — a plain query invalidation can't re-apply it. The provider registers
// an explicit reload here; the sync hook calls it when the agent changed
// targeting.
const targetingReloads = new Map();

export const registerTargetingReload = (campaignId, reload) => {
  targetingReloads.set(campaignId, reload);
  return () => {
    if (targetingReloads.get(campaignId) === reload) {
      targetingReloads.delete(campaignId);
    }
  };
};

export const reloadTargeting = (campaignId) => {
  const reload = targetingReloads.get(campaignId);
  if (reload) reload();
};
